/**
 * @module app.um
 */

import { autoinject } from 'aurelia-framework';
import { ComponentBase, IForm } from 'app/shared/lib/essette-site';
import { bindable } from 'aurelia-typed-observable-plugin';
import { apiCall } from 'app/shared/lib/essette-api';
import { Toaster } from 'app/shared/lib/toaster';
import { AdmissionCareDayService } from 'app/um/services/admission-care-day-service';
import * as UM from 'app/um/models/essette-api';

@autoinject()
export class SaveLevelOfCare extends ComponentBase implements IForm {

    ////****************** Fields and Properties ************************************////
    @bindable.object()
    public levelOfCare: UM.LevelOfCare = {};

    ////****************** Lifecycle events (in order of execution) *****************////

    constructor(
        private readonly service: AdmissionCareDayService,
        private readonly toaster: Toaster,
        ...rest: any[]) {
        super(...rest);
    }

    ////****************** Events ***************************************************////

    ////****************** Functions ************************************************////

    ////****************** IForm ****************************************************////
    public async reset(): Promise<void> { }

    public hasChanges(): boolean {
        throw new Error('Method not implemented.');
    }

    public async submit(): Promise<boolean> {
        return this.saveLevelOfCare();
    }

    ////****************** Service Calls ********************************************////

    @apiCall
    protected async saveLevelOfCare(): Promise<boolean> {
        let isSuccessful = false;
        try {
            this.state.beginSave();

            const response = await this.service.saveLevelOfCare(this.levelOfCare);
            isSuccessful = response.isSuccessful;
        }
        catch(error) {
            throw error;
        }
        finally {
            this.toaster.standard.saved('um:auth.levelOfCare.$', isSuccessful);
            this.state.endSave();
            return isSuccessful;
        }
    }
}
